module.exports = __webpack_public_path__ + "static/img/mag7.1308c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/mag7.png
// module id = Xo5D
// module chunks = 0